import React from 'react';
import { modules } from '../data/modules';
import { SectionHeading } from './SectionHeading';
export function Modules() {
  return <section className="bg-sand" data-id="element-168" data-mp="1r50zet82w436">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-169" data-mp="1r3zfs0czy99u">
        <SectionHeading eyebrow="Contenido de la guía" title={<>
              Mucho más que <span className="text-clay" data-id="element-171" data-mp="20uu3781zbewv">una introducción</span> al Feng Shui
            </>} data-id="element-170" data-mp="1vxu79pyufsjh" />

        <ol className="mx-auto mt-12 grid max-w-4xl gap-x-8 sm:mt-16 sm:grid-cols-2" data-id="element-172" data-mp="146xraghhl7rz">
          {modules.map((module, index) => <li key={module.number} className={`flex gap-4 py-6 sm:gap-5 sm:py-7 ${index === 0 ? 'border-t border-sage-line/70' : ''} ${index === 1 ? 'border-t-0 sm:border-t sm:border-sage-line/70' : ''} border-b border-sage-line/70`} data-id="element-173" data-mp="187zs31r1xrw2" data-mpi={index}>
              <span className="font-display text-[26px] font-semibold leading-none text-clay/60 sm:text-[30px]" aria-hidden="true" data-id="element-174" data-mp="2olq0ult494c1">
                {module.number}
              </span>
              <div data-id="element-175" data-mp="2tmnhgtyh9qbf">
                <h3 className="font-display text-[18.5px] font-semibold leading-snug text-ink sm:text-[20px]" data-id="element-176" data-mp="1ut4lp56jaub">
                  {module.title}
                </h3>
                <p className="mt-2 text-[13.5px] leading-[1.65] text-ink-soft sm:text-[14.5px]" data-id="element-177" data-mp="3twrci4ygc9et">
                  {module.description}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mt-10 text-center text-[13px] tracking-wide text-ink-mute sm:mt-12 sm:text-[14px]" data-id="element-178" data-mp="3k2scbbhxuzpi">
          + ejercicios · tablas · checklists · diagnósticos · ejemplos prácticos
        </p>
      </div>
    </section>;
}